import React from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from './Navigation';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";

const Layout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      {/* Add pt-16 to account for the fixed navbar height (h-16) */}
      <main className="flex-grow pt-16">
        {/* Apply container and padding here if needed globally, or manage within each page */}
        {/* Example: <div className="container mx-auto px-4 py-8"> */}
          <Outlet /> {/* Child routes will render here */}
        {/* </div> */}
      </main>
      {/* Render Toasters within the main layout */}
      <Toaster /> 
      <Sonner />
    </div>
  );
};

export default Layout; 